<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
             
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>

        <van-field
            readonly
            clickable
            :value="formData.year"
            input-align="right"
            label="申报时间"
            placeholder="点击选择年份"
            @click="showPicker = true"
        />

        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
              show-toolbar
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
          />
        </van-popup>
        <van-field
            readonly
            clickable
            :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
            autosize
            type="textarea"
            input-align="right"
            label="领取的比赛或活动名称"
            placeholder="点击选择领取的比赛或活动名称"
            @click="showSaiquPicker = true"
        />
        <van-notice-bar  
              text="四好运动员申报截止时间为比赛开始前10天"
              />
        <div class="operate-desc-left">报名运动员{{sai_member_count}}位,可报四好运动员{{member_limit}}位</div>

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="领取地址"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <!--        <van-field-->
        <!--            v-model="formData.getaddress"-->
        <!--            :rules="[{ required: true, message: '详细地址不能为空' }]"-->
        <!--            label="详细地址"-->
        <!--            input-align="right"-->
        <!--            error-message-align="right"-->
        <!--            clearable-->
        <!--            placeholder="请输入详细地址"-->
        <!--        />-->
        <van-field
            readonly
            clickable
            label="领取日期"
            input-align="right"
            error-message-align="right"
            placeholder="请选择领取日期"
            v-model="formData.getdate"
            :rules="[{ required: true, message: '请选择领取日期' }]"
            @click="showDate = true"/>

        <van-popup v-model="showDate" position="bottom">

          <van-datetime-picker
              type="date"
              title="选择年月日"
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onDateConfirm"
              @cancel="showDate=false"
          />
        </van-popup>

        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '单位名称不能为空' }]"
            label="领取单位"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入单位名称"
        />
        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '联系人名称不能为空' }]"
            label="联系人"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入联系人名称"
        />

        <van-field
            input-align="right"
            v-model="formData.phone"
            label="电话"
            :error="formValidate&&!formData.phone"
            type="number"
            placeholder="电话"
        />

        <van-divider>最多可选择{{member_limit}}位四好运动员哦</van-divider>

        <div style="text-align: center">
          <van-button
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round   v-if="member_limit>0"  @click="showYundongyuanPicker=true">选择运动员</van-button>

        </div>

        <div :key="index" v-for="(subject,index) in formData.member_list">
          <van-divider>四好运动员信息{{index+1}}
          </van-divider>
          <van-cell-group>
            <van-field
                v-model="subject.name"
                clearable
                input-align="right"
                error-message-align="right"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
            />
  
            <van-field 
                v-model="subject.num"
                clearable
                :rules="[{ required: true, message: '请输入证件号' }]"
                error-message-align="right"
                input-align="right"
                label="证件号"
                placeholder="请输入证件号"
            />
            <van-field
                v-model="subject.mingzu"
                clearable
                input-align="right"
                label="民族"
                placeholder="请输入民族"
            />

            <van-field
                v-model="subject.xueduan"
                clearable
                input-align="right"
                label="学段"
                :rules="[{ required: true, message: '请输入学段' }]"
                placeholder="请输入学段"
            >
            
                <template #input>
                    <van-radio-group v-model="formData.xueduan"  >
                        <van-radio checked-color="#ffb01b" name="幼儿园">幼儿园</van-radio>
                        <van-radio checked-color="#ffb01b" name="小学">小学</van-radio>
                        <van-radio checked-color="#ffb01b" name="初中">初中</van-radio>
                        <van-radio checked-color="#ffb01b" name="高中">高中</van-radio>
                        <van-radio checked-color="#ffb01b" name="大学">大学</van-radio>
                    </van-radio-group>
                </template>   
            </van-field>
            <div class="operate-desc-left">以下得分每项满分20，队内自行评分提交即可。</div>
            <van-field
                v-model="subject.score_pingde"
                clearable
                type="number"
                input-align="right"
                label="品德得分"
                placeholder="请输入品德得分"
            />

            <van-field
                v-model="subject.score_xuexi"
                clearable
                type="number"
                input-align="right"
                label="学段得分"
                placeholder="请输入学段得分"
            />

            <van-field
                v-model="subject.score_qizhi"
                clearable
                type="number"
                input-align="right"
                label="气质得分"
                placeholder="请输入气质得分"
            />
            <van-field
                v-model="subject.score_jishu"
                clearable
                type="number"
                input-align="right"
                label="技术得分"
                placeholder="请输入技术得分"
            />
            <van-field
                v-model="subject.score_toupiao"
                clearable
                type="number"
                input-align="right"
                label="投票得分"
                placeholder="请输入投票得分"
            />
            <div style="height: 0.2rem"></div>

          </van-cell-group>

          <div style="text-align: center">
            <van-button
                native-type="button"
                style="width: 3rem;"
                size="normal" round icon="close"   @click="memberRemove(subject,index)">删除运动员</van-button>
          </div>
        </div>

        <!-- <div style="text-align: center">
          <van-button
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round  icon="plus"  v-show="formData.member_list.length<member_limit" @click="memberAdd">新增运动员</van-button>

        </div> -->




<!--        <van-cell title="申报表" :value="formData.xlssrc.length+'/1'">-->
<!--          <template slot="icon">-->
<!--          </template>-->
<!--        </van-cell>-->

<!--        <div class="row">-->
<!--          <FileUploaderData uploadText="报名表" :fileList="formData.xlssrc" :limit="1" :startNum="2" accept=".xls,.xlsx"-->
<!--                            :name="'xlssrc'" @onGetData="onGetData"></FileUploaderData>-->

<!--        </div>-->
<!--        <div v-if="false" class="operate-desc-left">申报表模版下载</div>-->

        <div style="height: 10px"></div>
      </van-cell-group>
      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交申请
        </van-button>
      </div>
    </van-form>

    <SaiquPicker
        :show="showSaiquPicker"
        :limit="1"
        url="api/sai/clubSaiquOptions"
        :is_online='2'
        :start_date='now'
        :value="formData.extra_saiqu"
        @onChange="onSaiquChange"
        @onClose="showSaiquPicker=false"
        :defaultValue="formData.extra_saiqu"
        @onConfirm="onSaiquConfirm"
    ></SaiquPicker>


      <YundongyuanPicker
          :show="showYundongyuanPicker"
          :limit="member_limit"
          @onChange="onYundongyuanChange"
          @onClose="showYundongyuanPicker=false"
          :list="sai_member_list"
          :defaultValue="formData.member_list"
          @onConfirm="onYundongyuanConfirm"
      ></YundongyuanPicker>


  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import FileUploaderData from '@/components/picker/FileUploaderData.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanSihaoPicker.vue';
import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button, Dialog
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetailSihaoApply',
  components: {
    FileUploaderData, SaiquPicker,YundongyuanPicker
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      formValidate: false,
      showArea: false,
      showDate: false,
      showYundongyuanPicker: false,
      showPicker: false,
      showSaiquPicker: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      now : new Date().getTime()/1000,
      sai_member_count:0,
      sai_member_list:[],
      member_limit:0,
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(2030, 12, 30),
      currentDate: new Date(),
      columns: [2026,2025,2024,2023,2022,2021, 2020, 2019, 2018, 2017, 2016, 2015],
      formData: {
        id: 0,
        stationid: '',
        year: '',
        getdate: '',
        getaddress: '',
        danwei: '',
        name: '',
        phone: '',
        xlssrc: [], //excel模板文件
        extra_saiqu: [],
        member_list: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "申报四好运动员"
    that.areaList = area;
    that.club_id = this.$route.query.id;
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onConfirm(value) {
      this.formData.year = value;
      this.showPicker = false;
    },

    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onSaiquChange(values) {
      console.log('onSaiquChange', values) 
      let that =this;
      if(values.length>0){
        that.$api.post('/api/sai/getClubSaiquYdyMemberCount', {
          saiqu: values[0].id
        }, (res) => {
          that.sai_member_count = res.data.count;
          that.sai_member_list = res.data.list;
          // that.member_limit = parseInt(res.data.count/10);
          that.member_limit = res.data.member_limit
          that.formData.member_list = [];
        }, (res) => { 
        })
      }
      
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onDateConfirm(date) {
      this.showDate = false;
      this.formData.getdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      console.log('onDateConfirm', this.formData);

    },
    onYundongyuanConfirm(values) {
      this.showYundongyuanPicker = false;
      this.formData.member_list = [...values];
    },
    onYundongyuanChange(values) {
      console.log('onYundongyaunChange', values)
      this.formData.member_list = [...values];
    },

    memberAdd(){
      if(this.formData.member_list.length > 0) {
        let lastRow = this.formData.member_list[this.formData.member_list.length - 1]
        if(!lastRow.name) {
          Toast('请输入姓名');
          return
        }
        if(!lastRow.num) {
          Toast('请输入身份证号');
          return
        }
      }

      this.formData.member_list.push({
        id: 0,
        name:'',
        num:'',
        mingzu:'',
        xueduan:'',
        score_pingde:'',
        score_xuexi:'',
        score_qizhi:'',
        score_jishu:'',
        score_toupiao:'',
      })
    },
    memberRemove(item,index){
      let that = this;
      let notice = '确认删除项目'+(item.subject_name?'('+item.subject_name+')':'')+'吗?';
      that.formData.member_list.splice(index,1);
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!that.formData.year) {
          Toast('请选择年份');
          return
        }
        if (!that.formData.extra_saiqu.length) {
          Toast('请选择领取的比赛或活动名称');
          return
        }

        if (!that.formData.area) {
          Toast('请输入领取地点');
          return
        }
        if (!this.formData.danwei) {
          Toast('请输入领取单位');
          return
        }
        if (this.formData.member_list.length==0) {
          Toast('至少申报一位运动员');
          return
        }
      }

      that.formData.stationid = that.formData.extra_saiqu[0].id
      that.formData.club_id = that.club_id
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/cSihao/apply', that.formData, (res) => {
          that.saveLoading = false;
          Toast.success('新增成功')
          rbLink({
            name: "ClubDetailSihao",
          }, 'back')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onGetData(data) {
      console.log('onGetData', data)
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailSihaoApply.vue?0955818a